<div class="main">
  <div class="container d-flex flex-column justify-content-center align-items-center" style="width: 540px;">
    <div class="d-flex status-check" *ngIf="hasPendingProfile()">
      <img src="../../../../../../assets/images/icon/warning-org.svg" alt="">
      <span>Thông tin chưa cập nhật trên Trung tâm lưu ký chứng khoán</span>
    </div>
    <div class="d-flex">
      <form class="info-form" [formGroup]="editForm">
          <div class="row">
            <div class="form-group col-12">
              <label class="font-bold">{{'Email cũ' | translate}}
                <span class="required">*</span>
              </label>
              <input type="text" class="form-control" name="currentMail"
                formControlName="currentMail">
              <app-error-text
              [isDisplay]="isSaved && editForm.get('currentMail')?.errors?.required"
                  [message]="('Email cũ' | translate) + (' bắt buộc nhập' | translate)">
              </app-error-text>
              <app-error-text
              [isDisplay]="isSaved && errors.currentMail"
                  [message]="('Email cũ không đúng' | translate)">
              </app-error-text>
            </div>
            <div class="form-group col-12">
              <label class="font-bold">{{'Email mới' | translate}}
                <span class="required">*</span>
              </label>
              <input type="text"  autocomplete="off" class="form-control" name="pass" formControlName="newMail">
              <app-error-text class="error-text" [isDisplay]="isSaved && editForm.get('newMail')?.errors?.required"
                [message]="('product.create.required_field' | translate)">
              </app-error-text>
              <app-error-text class="error-text" [message]="('error.email_invalid' | translate)"
              [isDisplay]="isSaved && !editForm.get('newMail')?.errors?.required && editForm.get('newMail')?.errors?.pattern">
              </app-error-text>
            </div>
            <div class="d-flex w-100 justify-content-center">
              <button type="submit" (click)="save()" [disabled]="hasPendingProfile()"
              class="btn btn-save btn--blue btn-block">{{'Thay đổi' | translate}}</button>
            </div>
          </div>
      </form>
    </div>
  </div>
</div>
